import { getRequest } from '../services/requestHandler';
import { Loft } from '../models';

export const getLofts = async () => {
  const url = `loft/getlofts?activeOnly=true`;
  const response = await getRequest<Loft>('GetLofts', url);
  return response;
};
